import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Menu from "@/components/Menu";
import parse from "html-react-parser";
import Head from "next/head";
import { UseMeasureRef } from "react-use/lib/useMeasure";

function PageContainer({
	children,
	mainElementClasses,
	mainRef,
	script,
}: {
	children: React.ReactNode;
	mainElementClasses?: string;
	mainRef?: UseMeasureRef<HTMLElement>;
	script?: string | null;
}) {
	const parsedHtml = script ? parse(script) : null;

	return (
		<>
			<Head>{parsedHtml}</Head>
			<Menu />
			<div className="flex min-h-[calc(100vh-80px)] flex-col lg:min-h-screen">
				<Header />
				<main
					ref={mainRef}
					className={`relative mt-12 h-full min-h-[30rem] overflow-x-hidden pb-20 lg:mt-[7.5rem] ${mainElementClasses}`}
				>
					{children}
				</main>
				<Footer />
			</div>
		</>
	);
}

export default PageContainer;
